<div class="video-player-modal-container" id="VideoPlayerModalComponent">
    <youtube-player videoId="6WeXbhgipPc" suggestedQuality="highres" [playerVars]="playerVars"> </youtube-player>
    <div (click)="hide()" class="buttonBall close" id="EscUploadEntitiesClose"></div>
</div>
